import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { getBillingHistory } from 'features/account.settings/ui/billing_history/action';
import { useAction } from 'shared/hooks/redux/hooks';
import { useBooleanState } from 'shared/hooks/state/boolean';
import { Alert } from '@mui/material';
import { BillingHistoryTable } from 'features/account.settings/ui/billing_history/billing-history-table';
import { ErrorBoundary } from 'shared/components/error-boundary';
export function BillingHistoryPage() {
    const [history, setHistory] = useState([]);
    const [loading, noLoading, setLoading] = useBooleanState(false);
    const [error, setError] = useState(null);
    const onGetBillingHistory = useAction(getBillingHistory);
    useEffect(() => {
        (async () => {
            setLoading();
            const result = (await onGetBillingHistory());
            if (typeof result === 'string') {
                setError(result);
            }
            else {
                setHistory(result);
            }
            noLoading();
        })();
    }, []);
    const sorted_history = history.toSorted((a, b) => b.change_no - a.change_no);
    return (_jsxs(ErrorBoundary, { children: [loading && _jsx(Alert, { severity: "info", children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430" }), error != null && _jsx(Alert, { severity: "error", children: error }), _jsx(BillingHistoryTable, { history: sorted_history })] }));
}
BillingHistoryPage.isShown = (account) => !account.is_demo;
